const componentNames = {
  hu: {
    oldalak: "Oldalak",
    "Duplung-előlap": "Duplung-előlap",
    "Sima-Blat": "Sima-Blat",
    Munkalap: "Munkalap",
    "plafon, fenék": "Plafon, fenék",
    "Vízszintes kötés - matractartó": "Vízszintes kötés - matractartó",
    Válaszfal: "Válaszfal",
    Szokli: "Szokli",
    Plafon: "Plafon",
    Polc: "Polc",
    "Fiók-doboz": "Fiók-doboz",
    "Kis szekrény polcok": "Kis szekrény polcok",
    Polcok: "Polcok",
    "Plafon, fenék": "Plafon, fenék",
    Hátlemez: "Hátlemez",
    "Duplung-kötés": "Duplung-kötés",
    Oldalak: "Oldalak",
    "Kis szekrény oldal": "Kis szekrény oldal",
    "Nagy szekrény polcok": "Nagy szekrény polcok",
    "Plafon, fenék, kötés": "Plafon, fenék, kötés",
    Blat: "Blat",
    Kötés: "Kötés",
    "Sima vendéglap": "Sima vendéglap",
    "Hosszú merevítés": "Hosszú merevítés",
    "Fiók fenék": "Fiók fenék",
    "Szokli - első": "Szokli - első",
    "Kis szekrény plafon, fenék": "Kis szekrény plafon, fenék",
    "Kis szekrény homloklap": "Kis szekrény homloklap",
    Fiókelő: "Fiókelő",
    Ajtó: "Ajtó",
    Fenék: "Fenék",
    "Rövid merevítés": "Rövid merevítés",
    "Kis ágyvég": "Kis ágyvég",
    "Plafon/Fenék": "Plafon/Fenék",
    "Ágy oldalak": "Ágy oldalak",
    "Nagy ágyvég": "Nagy ágyvég",
    "Keskeny kötés": "Keskeny kötés",
    Blat: "Blat",
    Fiók: "Fiók",
    hátlemez: "Hátlemez",
    "Szokli - hátsó": "Szokli - hátsó",
    Doboz: "Doboz",
    Fiókok: "Fiókok",
    "Belső részek": "Belső részek",
    "Fiókos plafon fenék": "Fiókos plafon fenék",
    "Felső fiók": "Felső fiók",
    "Első-hátsó szokli": "Első-hátsó szokli",
    "Fiókos oldal - bal": "Fiókos oldal - bal",
    "Duplung-blat": "Duplung-blat",
    Ajtók: "Ajtók",
    "Duplung vendéglap": "Duplung vendéglap",
    "Ágy oldalak - Duplung": "Ágy oldalak - Duplung",
    "Nagy ágyvég - Duplung": "Nagy ágyvég - Duplung",
    "Kis ágyvég - duplung": "Kis ágyvég - duplung",
    "Bal oldali fiókok": "Bal oldali fiókok",
    "Fiókos oldal - jobb": "Fiókos oldal - jobb",
    "Alsó polcok": "Alsó polcok",
    "Felső polcok": "Felső polcok",
    Tolóajtók: "Tolóajtók",
    Lábak: "Lábak",
    "Duplungolt blat": "Duplungolt blat",
    Láb: "Láb",
    "Széles fiók": "Széles fiók",
    "Oldalsó szokli": "Oldalsó szokli",
    "Fiók alatti kötés": "Fiók alatti kötés",
    "Plafon-fenék": "Plafon-fenék",
    "Fiók közti kötés": "Fiók közti kötés"
  },
  ro: {
    oldalak: "Laterale",
    "Duplung-előlap": "Față dublă",
    "Sima-Blat": "Blat simplu",
    Munkalap: "Blat de lucru",
    "plafon, fenék": "Plafon, fund",
    "Vízszintes kötés - matractartó": "Legătură orizontală - suport saltea",
    Válaszfal: "Perete despărțitor",
    Szokli: "Soclu",
    Plafon: "Plafon",
    Polc: "Poliță",
    "Fiók-doboz": "Cutie sertar",
    "Kis szekrény polcok": "Polițe dulap mic",
    Polcok: "Polițe",
    "Plafon, fenék": "Plafon, fund",
    Hátlemez: "Spate",
    "Duplung-kötés": "Legătură dublă",
    Oldalak: "Laterale",
    "Kis szekrény oldal": "Lateral dulap mic",
    "Nagy szekrény polcok": "Polițe dulap mare",
    "Plafon, fenék, kötés": "Plafon, fund, legătură",
    Blat: "Blat",
    Kötés: "Legătură",
    "Sima vendéglap": "Panou simplu",
    "Hosszú merevítés": "Rigidizare lungă",
    "Fiók fenék": "Fund sertar",
    "Szokli - első": "Soclu - față",
    "Kis szekrény plafon, fenék": "Plafon, fund dulap mic",
    "Kis szekrény homloklap": "Frunte dulap mic",
    Fiókelő: "Față sertar",
    Ajtó: "Ușă",
    Fenék: "Fund",
    "Rövid merevítés": "Rigidizare scurtă",
    "Kis ágyvég": "Tăblie mică",
    "Plafon/Fenék": "Plafon/Fund",
    "Ágy oldalak": "Laterale pat",
    "Nagy ágyvég": "Tăblie mare",
    "Keskeny kötés": "Legătură îngustă",
    Fiók: "Sertar",
    hátlemez: "Spate",
    "Szokli - hátsó": "Soclu - spate",
    Doboz: "Cutie",
    Fiókok: "Sertare",
    "Belső részek": "Componente interioare",
    "Fiókos plafon fenék": "Plafon fund cu sertare",
    "Felső fiók": "Sertar superior",
    "Első-hátsó szokli": "Soclu față-spate",
    "Fiókos oldal - bal": "Lateral cu sertare - stânga",
    "Duplung-blat": "Blat dublu",
    Ajtók: "Uși",
    "Duplung vendéglap": "Panou dublu",
    "Ágy oldalak - Duplung": "Laterale pat - dublu",
    "Nagy ágyvég - Duplung": "Tăblie mare - dublă",
    "Kis ágyvég - duplung": "Tăblie mică - dublă",
    "Bal oldali fiókok": "Sertare laterale stânga",
    "Fiókos oldal - jobb": "Lateral cu sertare - dreapta",
    "Alsó polcok": "Polițe inferioare",
    "Felső polcok": "Polițe superioare",
    Tolóajtók: "Uși glisante",
    Lábak: "Picioare",
    "Duplungolt blat": "Blat dublat",
    Láb: "Picior",
    "Széles fiók": "Sertar lat",
    "Oldalsó szokli": "Soclu lateral",
    "Fiók alatti kötés": "Legătură sub sertar",
    "Plafon-fenék": "Plafon-fund",
    "Fiók közti kötés": "Legătură între sertare"
  },
  en: {
    oldalak: "Sides",
    "Duplung-előlap": "Double front panel",
    "Sima-Blat": "Simple top",
    Munkalap: "Worktop",
    "plafon, fenék": "Top, bottom",
    "Vízszintes kötés - matractartó": "Horizontal rail - mattress support",
    Válaszfal: "Partition",
    Szokli: "Plinth",
    Plafon: "Top panel",
    Polc: "Shelf",
    "Fiók-doboz": "Drawer box",
    "Kis szekrény polcok": "Small cabinet shelves",
    Polcok: "Shelves",
    "Plafon, fenék": "Top, bottom",
    Hátlemez: "Back panel",
    "Duplung-kötés": "Double rail",
    Oldalak: "Sides",
    "Kis szekrény oldal": "Small cabinet side",
    "Nagy szekrény polcok": "Large cabinet shelves",
    "Plafon, fenék, kötés": "Top, bottom, rail",
    Blat: "Top",
    Kötés: "Rail",
    "Sima vendéglap": "Simple panel",
    "Hosszú merevítés": "Long brace",
    "Fiók fenék": "Drawer bottom",
    "Szokli - első": "Plinth - front",
    "Kis szekrény plafon, fenék": "Small cabinet top, bottom",
    "Kis szekrény homloklap": "Small cabinet front",
    Fiókelő: "Drawer front",
    Ajtó: "Door",
    Fenék: "Bottom",
    "Rövid merevítés": "Short brace",
    "Kis ágyvég": "Small headboard",
    "Plafon/Fenék": "Top/Bottom",
    "Ágy oldalak": "Bed sides",
    "Nagy ágyvég": "Large headboard",
    "Keskeny kötés": "Narrow rail",
    Fiók: "Drawer",
    hátlemez: "Back panel",
    "Szokli - hátsó": "Plinth - back",
    Doboz: "Box",
    Fiókok: "Drawers",
    "Belső részek": "Internal parts",
    "Fiókos plafon fenék": "Drawer cabinet top bottom",
    "Felső fiók": "Top drawer",
    "Első-hátsó szokli": "Front-back plinth",
    "Fiókos oldal - bal": "Drawer side - left",
    "Duplung-blat": "Double top",
    Ajtók: "Doors",
    "Duplung vendéglap": "Double panel",
    "Ágy oldalak - Duplung": "Bed sides - double",
    "Nagy ágyvég - Duplung": "Large headboard - double",
    "Kis ágyvég - duplung": "Small headboard - double",
    "Bal oldali fiókok": "Left side drawers",
    "Fiókos oldal - jobb": "Drawer side - right",
    "Alsó polcok": "Lower shelves",
    "Felső polcok": "Upper shelves",
    Tolóajtók: "Sliding doors",
    Lábak: "Legs",
    "Duplungolt blat": "Doubled top",
    Láb: "Leg",
    "Széles fiók": "Wide drawer",
    "Oldalsó szokli": "Side plinth",
    "Fiók alatti kötés": "Rail under drawer",
    "Plafon-fenék": "Top-bottom",
    "Fiók közti kötés": "Rail between drawers"
  }
};

export default componentNames;
